import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosRowDirective } from './row.directive'


@NgModule({
  declarations: [IcosRowDirective],
  exports: [IcosRowDirective],
  imports: [CommonModule],
  entryComponents: [],
})
export class IcosRowModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosRowModule, providers: [] }
  }
}
